var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expired"},[_c('div',{staticClass:"expired__content"},[_c('p',{staticClass:"text"},[_vm._v("この配信は終了しました。")]),(!_vm.isCast)?_c('p',{staticClass:"text"},[_vm._v("他の配信をぜひお楽しみください。")]):_vm._e(),_c('button',{staticClass:"button",on:{"click":_vm.move}},[_vm._v(_vm._s(_vm.isCast ? "配信予定管理" : "出勤予定一覧"))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }